import { ConfigFileModel } from './configFileModel';

export enum DiffEntryStatus {
  ADDED = 'ADDED',
  REMOVED = 'REMOVED',
  MODIFIED = 'MODIFIED',
  UNMODIFIED = 'UNMODIFIED',
}

export interface DiffEntry {
  readonly resourceName: string;
  readonly status: DiffEntryStatus;
  readonly next?: {
    configFile: ConfigFileModel;
  };
  readonly prev?: {
    configFile: ConfigFileModel;
  };
}

export interface DiffModel {
  readonly diffs: DiffEntry[];
}
